/**
 * Environment for x client version.
 * @memberof EnvironmentVariable X_TALVIEW_CLIENT_VERSION
 */
export const xClientVersion: string =
  process.env.REACT_APP_X_TALVIEW_CLIENT_VERSION || "0.0.0";

export enum actionType {
  Alert = "alert",
}

/**
 * WebSocket URL for Livekit server.
 * @memberof EnvironmentVariable REACT_APP_LIVEKIT_WSURL
 */
export const livekitWSUrl = process.env.REACT_APP_LIVEKIT_WSURL;


/**
 * Growthbook URL for API host.
 * @memberof EnvironmentVariable GROWTHBOOK_API_HOST
 */
export const growthbookAPIHost = process.env.GROWTHBOOK_API_HOST;

/**
 * Growthbook Client Key.
 * @memberof EnvironmentVariable GROWTHBOOK_CLIENT_KEY
 */
export const growthbookClientKey = process.env.GROWTHBOOK_CLIENT_KEY;

/**
 *  Constants for canvas Dimensions for camera grab
 */
export const canvasDimensionsLandscape = {
  canvasWidth: 320,
  canvasHeight: 189
};

export const canvasDimensionsPortrait = {
  canvasWidth: 112,
  canvasHeight: 189,
};

// --- Twilio Video Constraint Iterations ---
export interface VideoConstraintIteration {
  maxVideoBitrate: number;
  camera: { width: number; height: number; frameRate: number };
}

export const VIDEO_CONSTRAINT_ITERATIONS: Record<number, VideoConstraintIteration> = {
  1: {
    maxVideoBitrate: 200000,
    camera: { width: 320, height: 180, frameRate: 2 },
  },
  2: {
    maxVideoBitrate: 200000,
    camera: { width: 320, height: 180, frameRate: 5 },
  },
  3: {
    maxVideoBitrate: 200000,
    camera: { width: 640, height: 360, frameRate: 2 },
  },
  4: {
    maxVideoBitrate: 200000,
    camera: { width: 640, height: 360, frameRate: 5 },
  }
};

/**
 * Returns the Twilio video constraint config for an org, if enabled by env var.
 * @param orgId Organization ID
 */
export function getTwilioVideoConstraintConfig(
  orgId: string | number
): VideoConstraintIteration | undefined {
  if (!orgId) return undefined;
  
  const orgIdStr = String(orgId);
  const orgIterationMappings = (process.env.REACT_APP_SCREEN_CONSTRAINT_ENABLED_ORG || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  const orgMapping = orgIterationMappings.find((mapping) => {
    const [mappedOrgId] = mapping.split("@");
    return mappedOrgId === orgIdStr;
  });

  if (!orgMapping) return undefined;

  const [, iterationStr] = orgMapping.split("@");
  const iteration = parseInt(iterationStr || "1", 10);

  return VIDEO_CONSTRAINT_ITERATIONS[iteration] || VIDEO_CONSTRAINT_ITERATIONS[1];
}
